import React from 'react';

import { cn } from '../../../lib/css/className/className';
import './Box.css';
import { RadioboxSize } from '../types';
import { getColorSkin } from '../../../lib/skin/getColorSkin/getColorSkin';

export interface BoxProps {
    size: RadioboxSize;
    isSelected?: boolean;
    isDisabled?: boolean;
    isHovered?: boolean;
    isFocused?: boolean;
}

const cnBox = cn('RadioboxBox');

export const Box = function Box(props: BoxProps) {
    const { isSelected, isHovered, isFocused, isDisabled, size } = props;
    const skinClass = getColorSkin(isSelected ? 'accent' : 'gray-transparent-contour', {
        isDisabled,
        isHovered,
    });

    return (
        <div
            className={cnBox(
                {
                    selected: isSelected,
                    focused: isFocused,
                    size,
                },
                [skinClass],
            )}
        />
    );
};
